import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/CheckPnrStatus.css';
import { CHECK_PNR_CARD } from '../constants/LtsConstants';
import { trackClickEventLTS } from '../../../utils/omnitureUtils';
import { PNR_CHECK_CLICKED } from '../constants/LtsTrackingConstants';
import { PROP_61 } from '../../../utils/omnitureUtilConstants';

function CheckPnrStatus({ customClass }) {
  const { DESCRIPTION_TEXT, TITLE_TEXT, PNR_PAGE_URL } = CHECK_PNR_CARD;
  return (
    <div className={`${customClass || ''} checkPnrStatus`}>
      <div className="checkPnrStatus--title">
        <span className="appendRight12 railSeoSprite pnrAlert" />
        <p>{TITLE_TEXT}</p>
      </div>
      <div className="checkPnrStatus--btn">
        <a
          className="blueButtonRails"
          href={PNR_PAGE_URL}
          onClick={() => {
            trackClickEventLTS(PNR_CHECK_CLICKED, PROP_61);
          }}
        >
          {DESCRIPTION_TEXT}
        </a>
      </div>
    </div>
  );
}

CheckPnrStatus.propTypes = {
  customClass: PropTypes.string
};

export default CheckPnrStatus;
